import { Skeleton } from "@/components/ui/skeleton";

interface CarouselSkeletonProps {
  count?: number;
}

export function CarouselSkeleton({ count = 5 }: CarouselSkeletonProps) {
  return (
    <div className="space-y-4">
      {/* Preview skeleton */}
      <Skeleton className="w-full h-[300px] sm:h-[400px] lg:h-[500px] rounded-xl" />

      {/* Thumbnail skeletons */}
      <div className="flex gap-3 overflow-hidden rounded-xl">
        {Array.from({ length: count }).map((_, i) => (
          <div
            key={i}
            className="flex-shrink-0"
            style={{ width: `calc(${100 / count}% - 0.5rem)` }}
          >
            <Skeleton className="aspect-square rounded-lg" />
          </div>
        ))}
      </div>
    </div>
  );
}
